import { isNullOrWhitespace } from './is-null-or-whitespace';

/**
 * Checks whether the given string is a guid
 * @param guid The guid to verify
 * @param allowDefaultGuid Whether the default guid ('00000000-0000-0000-0000-000000000000') is allowed
 * @param version Guid version to test

 */
export function IsGuid(guid: string, allowDefaultGuid = false, version: number = null) {
	if (isNullOrWhitespace(guid)) return false;
	return (
		(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(guid) && // check general guid format
			(version == null || guid[14] === version.toString())) || // check version number
		(allowDefaultGuid === true && guid === EmptyGuid()) // check default guid
	);
}

export function EmptyGuid() {
	return '00000000-0000-0000-0000-000000000000';
}
